export const a = [...Array(25).keys()].map((item) => item - 12);

export const t1 = a.reduce((a, b) => {
  let n;
  switch (b) {
    case -12:
      n = 0;
      break;
    case -11:
      n = 1;
      break;
    case -10:
      n = 2;
      break;
    case -9:
      n = 3;
      break;
    case -8:
      n = 4;
      break;
    case -7:
      n = 5;
      break;
    case -6:
      n = 6;
      break;
    case -5:
      n = 7;
      break;
    case -4:
      n = 8;
      break;
    case -3:
      n = 9;
      break;
    case -2:
      n = 10;
      break;
    case -1:
      n = 11;
      break;
    case 0:
      n = 12;
      break;
    case 1:
      n = 13;
      break;
    case 2:
      n = 14;
      break;
    case 3:
      n = 15;
      break;
    case 4:
      n = 16;
      break;
    case 5:
      n = 17;
      break;
    case 6:
      n = 18;
      break;
    case 7:
      n = 19;
      break;
    case 8:
      n = 20;
      break;
    case 9:
      n = 21;
      break;
    case 10:
      n = 22;
      break;
    case 11:
      n = 23;
      break;
    case 12:
      n = 24;
      break;
    default:
      n = 100;
  }
  return { ...a, [b]: n };
}, {});

export const t2 = a.reduce((a, b) => {
  let n;
  switch (b) {
    case -12:
    case -11:
      n = 0;
      break;
    case -10:
    case -9:
      n = 1;
      break;
    case -8:
    case -7:
      n = 2;
      break;
    case -6:
    case -5:
      n = 3;
      break;
    case -4:
    case -3:
      n = 4;
      break;
    case -2:
    case -1:
      n = 5;
      break;
    case 0:
      n = 6;
      break;
    case 1:
    case 2:
      n = 7;
      break;
    case 3:
    case 4:
      n = 8;
      break;
    case 5:
    case 6:
      n = 9;
      break;
    case 7:
    case 8:
      n = 10;
      break;
    case 9:
    case 10:
      n = 11;
      break;
    case 11:
    case 12:
      n = 12;
      break;
    default:
      n = 20;
  }
  return { ...a, [b]: n };
}, {});

export const t4 = a.reduce((a, b) => {
  let n;
  switch (b) {
    case -12:
    case -11:
    case -10:
    case -9:
      n = 0;
      break;
    case -8:
    case -7:
    case -6:
    case -5:
      n = 1;
      break;
    case -4:
    case -3:
    case -2:
    case -1:
      n = 2;
      break;
    case 0:
      n = 3;
      break;
    case 1:
    case 2:
    case 3:
    case 4:
      n = 4;
      break;
    case 5:
    case 6:
    case 7:
    case 8:
      n = 5;
      break;
    case 9:
    case 10:
    case 11:
    case 12:
      n = 6;
      break;
    default:
      n = 20;
  }
  return { ...a, [b]: n };
}, {});

export const t6 = a.reduce((a, b) => {
  let n;
  switch (b) {
    case -12:
    case -11:
    case -10:
    case -9:
    case -8:
    case -7:
      n = 0;
      break;
    case -6:
    case -5:
    case -4:
    case -3:
    case -2:
    case -1:
      n = 1;
      break;
    case 0:
      n = 2;
      break;
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      n = 3;
      break;
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 12:
      n = 4;
      break;
    default:
      n = 20;
  }
  return { ...a, [b]: n };
}, {});

export const t12 = a.reduce((a, b) => {
  let n;
  switch (b) {
    case -12:
    case -11:
    case -10:
    case -9:
    case -8:
    case -7:
    case -6:
    case -5:
    case -4:
    case -3:
    case -2:
    case -1:
      n = 0;
      break;
    case 0:
      n = 1;
      break;
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 12:
      n = 2;
      break;
    default:
      n = 20;
  }
  return { ...a, [b]: n };
}, {});

export const t25 = a.reduce((a, b) => {
    let n;
    switch (b) {
      case -12:
      case -11:
      case -10:
      case -9:
      case -8:
      case -7:
      case -6:
      case -5:
      case -4:
      case -3:
      case -2:
      case -1:
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
        n = 0;
        break;
      default:
        n = 20;
    }
    return { ...a, [b]: n };
  }, {});
